var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"top"},[_c('van-icon',{attrs:{"size":"80","color":"#26bd26","name":"passed"}}),_c('p',[_vm._v("交易完成")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }